import { useEffect } from 'react';

import { getCurrentLocation } from '@iwRouter/HistoryProvider';
import { getQueryParameter } from '@iwRouter/LocationHelper';

import { useNavVisibility } from '../../../../navigation/useNavVisibility';
import { useGetTellMoneyUserConsentByConsentId } from '../useGetTellMoneyUserConsentByConsentId';
import { usePostTellMoneyUserConsent } from '../usePostTellMoneyUserConsent';
import { ConsentReviewPrompt } from './ConsentReviewPrompt';

export const ConsentReviewView = () => {
    const location = getCurrentLocation();
    const consentId = getQueryParameter(location, 'ConsentId');
    const callbackUrl = getQueryParameter(location, 'CallbackURL');

    const { setShowNav } = useNavVisibility();
    const submitMutation = usePostTellMoneyUserConsent();

    const consent = useGetTellMoneyUserConsentByConsentId(consentId || '');

    useEffect(() => {
        setShowNav(false);
        return () => setShowNav(true);
    }, [setShowNav]);

    if (!consentId || !callbackUrl) {
        throw new Error(
            'Missing required query parameters: ConsentId or CallbackURL'
        );
    }

    const handleDecision = (approved: boolean) => {
        submitMutation.mutate(
            { consentId, approved },
            {
                onSuccess: ({ redirect_url }) =>
                    window.location.assign(redirect_url),
                onError: () => window.location.assign(callbackUrl)
            }
        );
    };

    const connectorName =
        consent.tpp_name === consent.app_name
            ? consent.tpp_name
            : `${consent.tpp_name} (${consent.app_name})`;

    return (
        <ConsentReviewPrompt
            connectorName={connectorName}
            permissions={consent.permissions}
            handleApprove={() => handleDecision(true)}
            handleDeny={() => handleDecision(false)}
            isLoading={submitMutation.isLoading}
        />
    );
};
